import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/carParkSettings/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/carParkSettings/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/carParkSettings/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/carParkSettings/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/carParkSettings/update', params,options);

export const sync = (params, options) =>
  request.post('/api/v4ward/carParkSettings/sync', qs.stringify(params),options);

export const getCarParkList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getCarParkList', Object.assign({}, options, { params }));

